import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    rubrics: [],
    contentfullClient: null,
    profil: null,
    link: null,
    tokentab: []
  },
  mutations: {
    setRubrics (state, { rubrics }) {
      state.rubrics = rubrics
    },
    setContentfullClient (state, { client }) {
      state.contentfullClient = client
    },
    setToken (state, { token }) {
      state.tokentab = token.split(';')
      state.profil = state.tokentab[0]
      state.link = state.tokentab[2]
    }
  },
  actions: {

  },
  getters: {
    authorizedRubrics (state) {
      let okRubrics = []
      state.rubrics.forEach(e => {
        let rubric = e
        if (rubric.destinations === null || rubric.destinations === undefined) {
          okRubrics.push(rubric)
        } else if (rubric.destinations.includes(state.profil) && state.profil != null) {
          okRubrics.push(rubric)
        }
        if (rubric.pages) {
          let okPages = []
          rubric.pages.forEach(x => {
            let page = x
            if (page.destinations === null || page.destinations === undefined) {
              okPages.push(page)
            } else if (page.destinations.includes(state.profil) && state.profil != null) {
              okPages.push(page)
            }
          })
          rubric.pages = okPages
        }
      })
      return okRubrics
    }
  }
})
